import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-admin-add-web-pages',
  templateUrl: './admin-add-web-pages.component.html',
  styleUrls: ['./admin-add-web-pages.component.css']
})
export class AdminAddWebPagesComponent implements OnInit {

  webpageForm!: FormGroup;
  
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.webpageForm = this.formBuilder.group({
      title: [''],
      notes: [''],
    })
  }

}
